<template lang="pug">
  main#index(itemprop="mainContentOfPage")
    //-
      Who is Jorge?
    SectionHello

    //---------------------
      Front-End Development
    Section01
    //-
      Design & UI/UX
    Section02
    //-
      Portfolio
    Section03
    //---------------------

    //-
      Get in touch
    SectionContact

    //---------------------
    AppFooter
</template>

<script>
  import SectionHello from '@/components/sections/SectionHello'
  import Section01 from '@/components/sections/Section01'
  import Section02 from '@/components/sections/Section02'
  import Section03 from '@/components/sections/Section03'
  import SectionContact from '@/components/sections/SectionContact'
  //
  import AppFooter from '@/components/core/Footer'

  export default {
    name: 'Index',

    components: {
      SectionHello,
      Section01,
      Section02,
      Section03,
      SectionContact,
      //
      AppFooter
    }

  }
</script>

<style lang="sass" scoped>
  #index
    section
      z-index: 1
      position: relative
      &:not(:first-child)
        // background-color: #fafafa
        margin: 0 auto
        padding: 0 2.5rem
        width: 100%
        max-width: 1920px
      +breakpoint(md)
        padding: 2rem 2.5rem
</style>



// WEBPACK FOOTER //
// src/views/Index.vue